const ONBOARDING_QUESTIONNAIRE_QUERY_KEY = ['onboarding', 'useOnboardingQuestionnaire'] as const;

export default ONBOARDING_QUESTIONNAIRE_QUERY_KEY;
